import { Box, type BoxProps } from '@mui/material'
import { forwardRef } from 'react'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'

export const SettleLogo = forwardRef<HTMLImageElement, BoxProps>(({ sx, ...props }, ref) => (
  <>
    {(!process.env.BRAND || process.env.BRAND === 'settle') && (
      <Box
        component="img"
        src="/assets/settle_v2.svg"
        title="Settle"
        {...props}
        ref={ref}
        sx={mergeSx({ width: '63px', height: '18px' }, sx)}
      />
    )}
    {process.env.BRAND === 'escalon' && (
      <Box
        component="img"
        src="/assets/escalon_v2.svg"
        title="Escalon"
        {...props}
        ref={ref}
        sx={mergeSx({ width: '161px', height: '28px' }, sx)}
      />
    )}
  </>
))

SettleLogo.displayName = 'SettleLogo'
